import TreeViewContentWeb from "../../components/Web/TreeViewContentWeb";

const TreeViewWeb = () => {
  return <TreeViewContentWeb />;
};

export default TreeViewWeb;
